import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PlatformAdmin } from "@/lib/api";

interface AuthState {
  admin: PlatformAdmin | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  // Actions
  setAdmin: (admin: PlatformAdmin | null) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      admin: null,
      isAuthenticated: false,
      isLoading: true,

      setAdmin: (admin) =>
        { set({
          admin,
          isAuthenticated: admin !== null,
          isLoading: false,
        }); },

      setLoading: (isLoading) => { set({ isLoading }); },

      clearAuth: () =>
        { set({
          admin: null,
          isAuthenticated: false,
          isLoading: false,
        }); },
    }),
    {
      name: "admin-auth-storage",
      partialize: (state) => ({
        admin: state.admin,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

// Selector hooks
export const useAdmin = () => useAuthStore((state) => state.admin);
export const useIsAuthenticated = () =>
  useAuthStore((state) => state.isAuthenticated);
export const useIsLoading = () => useAuthStore((state) => state.isLoading);
